import React, { ReactNode } from "react";
import styles from "./container-pane.module.scss";

interface ContainerPanePropTypes {
  children: ReactNode;
  backgroundColor?: string;
}

const cssClassName = "container-pane";

export const ContainerPane = ({
  children,
  backgroundColor = "#152125",
}: ContainerPanePropTypes) => {
  return (
    <div
      className={styles[cssClassName]}
      style={{ backgroundColor: backgroundColor }}
    >
      {children}
    </div>
  );
};
